module.exports = __webpack_public_path__ + "static/Benidorm-df4a6fd9d47b01268afc9d0b84cd049e.jpg";